@if (note(); as currentNote) {
  @if (shareNote()) {
    <nr-note-share-dialog (dialogClosed)="handleShareClose()"></nr-note-share-dialog>
  } @else if (currentNote.isShared) {
    <nr-shared-note-dialog (dialogClosed)="handleClose()"></nr-shared-note-dialog>
  } @else {
    <nr-note-dialog (dialogClosed)="handleClose()"></nr-note-dialog>
  }
}
